import { render } from "./EjwBrand.vue?vue&type=template&id=2bd323b0&scoped=true"
import script from "./EjwBrand.vue?vue&type=script&lang=js"
export * from "./EjwBrand.vue?vue&type=script&lang=js"

import "./EjwBrand.vue?vue&type=style&index=0&id=2bd323b0&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bd323b0"]])

export default __exports__